import {
  Box,
  capitalize,
  CircularProgress,
  IconButton,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import Iconify from 'src/components/Iconify';
import { spreadSxProp } from 'src/utils/cssStyles';
import { Section } from 'src/utils/layout';

export interface EditableCardProps {
  children: React.ReactNode;
  title: string;
  onEditButtonPress?: VoidFunction;
  showEditButton?: boolean;
  button?: React.ReactNode;
  titleContainerSx?: SxProps;
  isLoading?: boolean;
  fullWidth?: boolean;
}

export const EditableCard = ({
  title,
  onEditButtonPress,
  children,
  showEditButton = true,
  button,
  titleContainerSx,
  isLoading,
  fullWidth = true,
}: EditableCardProps) => (
  <Section fullWidth={fullWidth}>
    <Box sx={{ paddingX: 1, paddingY: 2 }}>
      <Stack direction="row" sx={[{ display: 'flex' }, ...spreadSxProp(titleContainerSx)]}>
        <Typography variant="button" sx={{ textTransform: 'capitalize' }}>
          {title}
        </Typography>
        {!!(button && !showEditButton) && button}
        {!!showEditButton && (
          <IconButton
            sx={{ position: 'relative', top: -10, marginLeft: 0.6 }}
            onClick={() => onEditButtonPress?.()}
          >
            <Iconify icon={'eva:edit-outline'} />
          </IconButton>
        )}
      </Stack>
      {!isLoading ? (
        <Box sx={{ marginTop: 0 }}>{children}</Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={55} />
        </Box>
      )}
    </Box>
  </Section>
);

export interface InfoItemProps {
  label: string;
  value: string | null | undefined;
}

export const InfoItem = ({ label, value }: InfoItemProps) => (
  <Box>
    <Typography
      variant="body2"
      sx={{ color: 'text.secondary', fontWeight: 'bold', marginBottom: 0.4 }}
    >
      {label}
    </Typography>
    <Typography variant="body2">{capitalize(value ?? '')}</Typography>
  </Box>
);

export interface InfoBannerItemProps {
  label: string;
  value?: string | null;
  capitalize?: boolean;
}

export const InfoBannerItem = ({ label, value, capitalize = true }: InfoBannerItemProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', marginRight: 3 }}>
    <Typography
      variant="body2"
      sx={{
        fontWeight: 'bold',
        color: 'text.secondary',
        marginRight: 0.7,
        whiteSpace: 'nowrap',
      }}
    >
      {label}:
    </Typography>

    <Typography
      variant="body2"
      sx={{
        textTransform: capitalize ? 'capitalize' : undefined,
        whiteSpace: 'nowrap',
      }}
    >
      {value ?? ''}
    </Typography>
  </Box>
);
